import $http from '$http';
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from 'utils';
import {
  GetProvinces,
  GetCitys,
  GetAreas,
  GetAgentList,
  GetParmConfig, //寄送，支付接口
  GetProductClass,
  GetAgentConsigneeList,
  Consignee_Add,
  GetEmployList,
  ConsigneeSetDefault
} from '@api/commonApi.js';
import {
  GetOrderFinanceAuditByPage,
  ERP_AuditOrder,
  GetERP_OrderById
} from '@api/orderApi';
export default {
  methods: {
    //获取列表
    //初始化加载页面
    getList() {
      var params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value != '') {
          params[item] = value;
        }
      }
      this.lists = [];
      this.loading = true; //拼命加载中显示
      $http.get("api/Agent/Agent_HiBookList", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.lists = Data;
          this.totalSize = Cnt;
        });

      });

    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Agent/hiPackage/services.js